import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public isLoading = false;

  constructor() { }

  showLoading(): void {
    this.isLoading = true;
  }
 
  hideLoading(): void {
    this.isLoading = false;
  }
 
  getLoadingState(): boolean {
    return this.isLoading;
  }
}
